import { Box, Image } from '@chakra-ui/react';
import dynamic from 'next/dynamic'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useState, useEffect } from 'react';
import { getDashboardLayout } from '@/components/Layouts/getDashboardLayout';
import { NextPageWithLayout } from '@/pages/_app';
import SignIn from '@/routes/SignIn';

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common', 'pages/signin'])),
  },
});
const P5Gradation = dynamic(
  () => import('@/components/Elements/P5Animation'),
  { ssr: false }
)
const Index: NextPageWithLayout = () => {
  const [isP5GradationVisible, setIsP5GradationVisible] = useState(true);
  useEffect(() => {
    const handleResize = () => {
      setIsP5GradationVisible(window.innerWidth > 820);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <>
      {isP5GradationVisible && <P5Gradation />}
      {/* モバイルの時とP5がレンダリングされるまでの間にpngの背景を配置
      The backgroundImage is placed between the time of mobile and when P5 is rendered. */}
      <Box
        width="100%"
        height='100%'
        position="fixed"
        top="0"
        left="0"
        zIndex="-2"
      >
        <Image
          h="100%"
          src="/images/pages/background.png"
          alt=""
        />
      </Box>
      <SignIn />
    </>
  );
};

Index.getLayout = getDashboardLayout();

export default Index;
